/**
 * Web stub for KeyboardAwareScrollView
 * On web, just use a simple scrollable div
 */
import React from 'react';

const KeyboardAwareScrollViewComponent = React.forwardRef<any, any>(
  (
    {
      keyboardShouldPersistTaps,
      enableOnAndroid,
      enableAutomaticScroll,
      keyboardOpeningTime,
      extraScrollHeight,
      extraHeight,
      style,
      children,
      ...props
    }: any,
    ref: any
  ) => {
    return (
      <div
        ref={ref}
        style={{
          overflow: 'auto',
          ...style,
        }}
        {...props}
      >
        {children}
      </div>
    );
  }
);

KeyboardAwareScrollViewComponent.displayName = 'KeyboardAwareScrollView';

export const KeyboardAwareScrollView = KeyboardAwareScrollViewComponent;

export default KeyboardAwareScrollViewComponent;
